import { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { useForm } from 'utils/hooks'
import { Flex } from 'components/shared/flex'
import '../preview.scss'
import { CheckTestView } from './check_test_view'
import { CheckHabit, CheckSample } from 'entities/check_sample'
import { CheckTestResultForm } from 'api/result_check'
import { CheckPdfResult } from '@craif/product.pdf-result'

type Props = {
    history: H.History
}

const TestResultCheck = (props: Props) => {
    const [testCheckSample, setTestCheckSample] = useState<CheckSample>()
    const [habits, setHabits] = useState<CheckHabit[]>([])
    const form = useForm<CheckTestResultForm>({
        enabled: true,
        inspectionDate: '2024-06-01',
        resultValue: 0,
        level: 0,
        habits: [],
    })
    const formPrev = useForm<CheckTestResultForm>({ inspectionDate: '2024-06-01', enabled: false, resultValue: 0, habits: [] })
    const formPrev2 = useForm<CheckTestResultForm>({ inspectionDate: '2024-05-01', enabled: false, resultValue: 0, habits: [] })
    const formPrev3 = useForm<CheckTestResultForm>({ inspectionDate: '2024-04-01', enabled: false, resultValue: 0, habits: [] })
    const formPrev4 = useForm<CheckTestResultForm>({ inspectionDate: '2024-03-01', enabled: false, resultValue: 0, habits: [] })

    useEffect(() => {
        const f = async () => {
            setHabits([
                { label: 'uv', value: 1, key: 'uv' },
                { label: 'stress', value: 1, key: 'stress' },
                { label: 'busy', value: 1, key: 'busy' },
                { label: 'smoking', value: 1, key: 'smoking' },
                { label: 'alcohol', value: 1, key: 'alcohol' },
                { label: 'sleep', value: 1, key: 'sleep' },
                { label: 'exercise', value: 1, key: 'exercise' },
                { label: 'vegetable', value: 1, key: 'vegetable' },
            ])
        }
        f()
    }, [])

    return (
        <>
            <Flex>
                <div className="no-print" style={{ width: 350, fontSize: 12, position: 'sticky', top: 0, zIndex: 100 }}>
                    <div style={{ padding: 10, backgroundColor: 'white', marginTop: 10, height: '95vh', overflow: 'scroll' }}>
                        <CheckTestView
                            form={form}
                            formPrev={formPrev}
                            formPrev2={formPrev2}
                            formPrev3={formPrev3}
                            formPrev4={formPrev4}
                            habits={habits}
                            setSample={setTestCheckSample}
                        />
                    </div>
                </div>
                <div>{testCheckSample && <CheckPdfResult checkSample={testCheckSample as any} />}</div>
            </Flex>
        </>
    )
}

export default withRouter(TestResultCheck)
